import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HOME_DESCRIPTION, SITE_URL } from "@/lib/brand";

const pages = {
  "/": ["Keepsake Books | Personalised Books Made From Your Memories", HOME_DESCRIPTION],
  "/contact": ["Contact Keepsake Books | Help With Your Personalised Book", "Contact Keepsake Books about your order, delivery, personalisation, revisions and privacy."],
  "/privacy": ["Privacy Policy | Keepsake Books", "Read the existing privacy policy and operational review notes for Keepsake Books."],
  "/projects": ["Your Saved Books | Keepsake Books", "Return to your personal Keepsake book projects on this browser."],
};
const privateTitles = { create: "Create Your Keepsake", preview: "Your Book Draft", product: "Choose Your Book", checkout: "Checkout", order: "Your Order", admin: "Administration" };
export const PageMetadata = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const section = pathname.split("/")[1];
    const [title, description] = pages[pathname] || [`${privateTitles[section] || "Keepsake Books"} | Keepsake Books`, "Your personalised Keepsake book." ];
    document.title = title;
    const meta = (selector, content) => { const el = document.querySelector(selector); if (el) el.setAttribute("content", content); };
    meta('meta[name="description"]', description);
    meta('meta[property="og:title"]', title);
    meta('meta[property="og:description"]', description);
    meta('meta[name="twitter:title"]', title);
    meta('meta[name="twitter:description"]', description);
    const publicRoute = ["/", "/contact", "/privacy"].includes(pathname);
    const previewHost = SITE_URL && window.location.origin !== SITE_URL;
    meta('meta[name="robots"]', publicRoute && !previewHost ? "index,follow" : "noindex,nofollow");
    const canonical = SITE_URL + (publicRoute ? pathname : "/");
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonical);
    meta('meta[property="og:url"]', canonical);
    if (hash) requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView());
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};